// Common Vue.js setup for all pack files
import { globalMixin, globalFilters } from './global.js';
import PostCard from '../components/bootstrap/post-card.vue';
import PostCardHeader from '../components/bootstrap/post-card-header.vue';
import PostCollapse from '../components/bootstrap/post-collapse.vue';
import { postToggle } from '../directives/post-toggle.js';

export function setupVueApp(app) {
  // Configure compatibility mode
  app.config.compatConfig = {
    MODE: 2,
    GLOBAL_EXTEND: true,
    GLOBAL_MOUNT: true,
    GLOBAL_PROTOTYPE: true,
    RENDER_FUNCTION: true,
    INSTANCE_SCOPED_SLOTS: true,
    OPTIONS_DATA_MERGE: true
  };
  
  // Vue 3 compiler options
  app.config.compilerOptions = {
    whitespace: 'condense'
  };

  // Register custom Bootstrap components globally
  app.component('PostCard', PostCard);
  app.component('PostCardHeader', PostCardHeader);
  app.component('PostCollapse', PostCollapse);

  // Register custom directive
  app.directive('post-toggle', postToggle);

  // Add global properties
  app.config.globalProperties.$filters = globalFilters;

  return app;
}